export const tvNext = {
  name: "tv-next" as const,
  svg: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M21 21h-1V3h1v18Zm-3-9L4.5 19.794V4.206L18 12Z"/><path fill-rule="evenodd" d="M19.364 2.364A.9.9 0 0 1 20 2.1h1a.9.9 0 0 1 .9.9v18a.9.9 0 0 1-.9.9h-1a.9.9 0 0 1-.9-.9V3a.9.9 0 0 1 .264-.636ZM4.05 3.426a.9.9 0 0 1 .9 0l13.5 7.795a.9.9 0 0 1 0 1.558l-13.5 7.795a.9.9 0 0 1-1.35-.78V4.206a.9.9 0 0 1 .45-.78ZM5.4 5.765v12.47L16.2 12 5.4 5.765Z" clip-rule="evenodd"/></svg>`,
  keywords: ["tv-next"],
  category: "action" as const,
};
